import { clsx } from 'clsx';

interface Props {
  value: number | null | undefined;
  label?: string;
  size?: 'sm' | 'md';
  color?: 'blue' | 'indigo' | 'purple';
}

const colorMap = {
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  purple: 'bg-purple-500',
};

function getColor(value: number, base: 'blue' | 'indigo' | 'purple'): string {
  if (value > 90) return 'bg-red-500';
  if (value > 70) return 'bg-yellow-500';
  return colorMap[base];
}

export function MetricBar({ value, label, size = 'sm', color = 'blue' }: Props) {
  const v = value ?? 0;
  const height = size === 'sm' ? 'h-1.5' : 'h-2';

  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-xs text-gray-500 dark:text-gray-400 w-8">{label}</span>}
      <div className={clsx('w-20 rounded-full bg-gray-200 dark:bg-gray-700', height)}>
        <div
          className={clsx('rounded-full transition-all', height, getColor(v, color))}
          style={{ width: `${Math.min(100, v)}%` }}
        />
      </div>
      <span className="text-xs font-medium text-gray-600 dark:text-gray-400 w-8 text-right">
        {value != null ? `${Math.round(v)}%` : '-'}
      </span>
    </div>
  );
}
